import { FileText } from "lucide-react";

// The shape every plan review query asks for through its `submission_type` relationship.
export interface SubmissionType {
	name: string;
	short_name?: string | null;
}

interface SubmissionTypeBadgeProps {
	submissionType?: SubmissionType | null;
	// The full name ("Building / Tenant Finish-Out") instead of the compact one.
	full?: boolean;
	className?: string;
}

/**
 * The submission type of a plan review, shown wherever the project is identified:
 * the dashboard row, its submission history, and each submission's report.
 *
 * Renders nothing for a project without one — those predate the catalogue — so the
 * surrounding row keeps its shape.
 */
const SubmissionTypeBadge = ({ submissionType, full = false, className = "" }: SubmissionTypeBadgeProps) => {
	if (!submissionType) return null;

	return (
		<span className={`stb-badge ${className}`.trim()}>
			<FileText className="stb-badge-icon" size={14} />
			{full ? submissionType.name : (submissionType.short_name ?? submissionType.name)}
		</span>
	);
};

export default SubmissionTypeBadge;
